import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { IArticle } from '../models/article';

import './article-card.scss';
import Moment from 'react-moment';

interface CardProps {
  article: IArticle;
}

export const ArticleCard: React.FC<CardProps> = ({ article }) => {
  return (
    <Link to={`/article/${article.slug}`} className="article-card">
      <div className="article-card__image-container">
        {article.image && (
          <GatsbyImage
            className="article-card__image"
            alt={article.image.alternativeText}
            image={article.image.localFile.childImageSharp.gatsbyImageData}
          />
        )}
      </div>
      <div className="article-card__content">
        <div className="article-card__meta">
          <div className="article-card__category">{article.category.name}</div>
          <div className="article-card__time-to-read">
            {article.childStrapiArticleContent.childMarkdownRemark.timeToRead}{' '}
            min read
          </div>
        </div>
        <h2 className="article-card__title">{article.title}</h2>
        <div className="article-card__author">
          {article.author.picture && (
            <div className="article-card__author__portrait-container">
              <GatsbyImage
                className="article-card__author__portrait"
                alt={article.author.picture.alternativeText}
                image={
                  article.author.picture.localFile.childImageSharp
                    .gatsbyImageData
                }
              />
            </div>
          )}
          <div className="article-card__author__right">
            <div className="article-card__author__name">
              {article.author.name}
            </div>
            <div className="article-card__author__date">
              <Moment format="MMM Do YYYY">{article.publishedAt}</Moment>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
